import React from 'react';
import {Button, Form, Header, Icon, Loader, Popup, Segment, Tab, Table} from 'semantic-ui-react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import CreateCourse from './CreateCourse';
import AddStaff from './AddStaff';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import { toast, ToastContainer } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema implementacija ovog predmeta za odabranu godinu.</p>;
const NoDataMessageCurrent = () => <p>Nema implementacija ovog predmeta.</p>;

export default class CourseImplementations extends React.Component {
    constructor(props) {
        super(props);
        let storedId = '';

        if (localStorage.getItem('courseBasicId')) {
            storedId = parseInt(localStorage.getItem('courseBasicId'), 10);
        }

        this.state = {
            data: [],
            previousYear: 41,
            activeIndex: 0,
            current: [],
            previous: [],
            courseImplementationId: '',

            newImplementationMode: false,
            addStaffMode: false
        };
        this.addStaff = this.addStaff.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.editImplementation = this.editImplementation.bind(this);
        this.deleteImplementation = this.deleteImplementation.bind(this);
    }

    handleInputChange(event, { name, value }) {
        if (name === 'previousYear') {
            this.getImplementations(localStorage.getItem('courseBasicId'), value);
        }

        this.setState({
            [name]: value
        });
    }
    componentWillUpdate(nextProps, nextState, nextContext) {
    let element = document.querySelectorAll('#myTab:nth-child(1)');
    element[0].childNodes[1].classList.remove('segment');
    }

    componentDidMount() {
        axios.get('/academic-years/current')
            .then(res => {
                this.setState({
                    currentYear: res.data.id
                });
            })
        axios.get('/academic-years/previous')
            .then(res => {
                this.setState({
                    previousYear: res.data.id
                });
            })

        axios.get('/academic-years/all-previous/')
            .then(res => {
                this.setState({
                    previousYearOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    })).reverse(),
                });
            })

        if(localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu'){
            axios.get(`course/third-cycle-check/${localStorage.getItem('courseBasicId')}/`).then((res=>{
                this.setState({thirdCycle:res.data})
            })).then(()=>{

                axios.get(`course/specialist-study-program-check/${localStorage.getItem('courseBasicId')}/`).then((res=>{
                    this.setState({specialist:res.data})
                })).then(()=>{
                    this.getImplementations(localStorage.getItem('courseBasicId'));
                })
            })
        }
        this.getImplementations(localStorage.getItem('courseBasicId'));

    }


    getImplementations(id, previousYearId = false) {
        this.setState({ loader: true });
        axios.get('/academic-years/current')
            .then(res => {
                this.setState({ currentYearId: res.data.id });
                axios.get(`course/implementations/by-course-basic-and-academic-year/${id}/${this.state.currentYearId}/`)
                    .then(ress => {
                        this.setState({ current: ress.data.sort((a, b) => b.semesters[0].academicYear.startYear - a.semesters[0].academicYear.startYear) });
                        this.setState({ loader: false });
                    })
                    .catch(err => {
                        console.log('Failed to fetch course implementations');
                    });
                if (previousYearId) {
                    axios.get(`course/implementations/by-course-basic-and-academic-year/${id}/${previousYearId}/`)
                        .then(ress => {
                            this.setState({ previous: ress.data.sort((a, b) => b.semesters[0].academicYear.startYear - a.semesters[0].academicYear.startYear) });
                            this.setState({ loader: false });
                        })
                        .catch(err => {
                            this.setState({ loader: false });
                            console.log('Failed to fetch course implementations');
                        });
                }
            });
    }
    handleTabChange = (e, { activeIndex }) => {
        this.setState({ activeIndex });
        this.getImplementations(localStorage.getItem('courseBasicId'),this.state.previousYear);


    };

    addStaff() {
        axios.post('course/implementations/staff/')
            .then(res => {
                this.setState({ data: res.data });
            })
            .catch(err => {
                console.log('Failed to fetch course implementations');
            });
    }

    editImplementation(comment, commentForStaff){
        let obj = {...this.state.courseImplementation, comment, commentForStaff}

        axios.put('course/edit-implementation-comment', obj)
            .then(res => {
                toast('Uspješno ste izmijenili implementaciju.');
                this.setState({showEditForm:false})
                this.getImplementations(localStorage.getItem('courseBasicId'),this.state.previousYear);
            })
            .catch(err => {
                console.log('Došlo je do greške.');
            });
    }


    deleteImplementation(id){
        axios.delete(`course/delete-implementation/${id}`)
            .then(res => {
                toast('Uspješno ste izbrisali implementaciju.');
                this.getImplementations(localStorage.getItem('courseBasicId'),this.state.previousYear);
            })
            .catch(err => {
                if (err.response.data === 'There are students enrolled in this course implementation!') {
                    toast('Došlo je do greške! Implementacija nije izbrisana jer postoje upisani studenti na ovu implementaciju.');
                } else if (err.response.data === 'Staff is added for this course implementation!') {
                    toast('Došlo je do greške! Implementacija nije izbrisana jer postoji osoblje dodano na ovu implementaciju.');
                } else if (err.response.data === 'There are groups created for this course implementation!') {
                    toast('Došlo je do greške! Implementacija nije izbrisana jer postoje grupe na ovoj implementaciji.');
                } else if (err.response.data === 'There are exams created for this course implementation!') {
                    toast('Došlo je do greške! Implementacija nije izbrisana jer postoje ispiti kreirani na ovoj implementaciji.');
                } else if (err.response.data === 'There are questionnaire links created for this course implementation!') {
                    toast('Došlo je do greške! Implementacija nije izbrisana jer je ova implementacija povezana sa anketom.');
                } else if (err.response.data === 'Could not delete course implementation with passed id!') {
                    toast('Došlo je do greške! Implementacija nije izbrisana.');
                } else toast('Došlo je do greške! Implementacija nije izbrisana.');
            });
    }


    render() {
        const panes = [
            {
                menuItem: 'Trenutna akademska godina',
                render: () => (<Tab.Pane >
                    { this.state.loader ?  <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :
                        this.state.current.length ?
                            <Table celled selectable compact>
                                <Table.Header>
                                    <Table.Row>

                                        <Table.HeaderCell colSpan={2}>
                                        Semestar (akademska godina)
                                        </Table.HeaderCell>

                                        <Table.HeaderCell width="2">
                                        Predavanja + vježbe
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width="1">
                                        ECTS
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width="1">
                                            Šifra
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={3}>
                                        Napomena
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={3}>
                                            <Header as="h4" image>
                                                <Header.Content>
                                                    Napomena
                                                    <Header.Subheader>za profesore</Header.Subheader>
                                                </Header.Content>
                                            </Header>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={1}/>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {this.state.current.map((el, index) =>
                                    (<Table.Row key={el.id}>

                                        <Table.Cell verticalAlign="middle" colSpan={2}>
                                            {el.semesters.length ? el.semesters[0].name.name : ''} ({el.semesters.length ? el.semesters[0].academicYear.name : ''})
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width="2">
                                            {el.lectureNumber ? el.lectureNumber : '0'} + {el.exerciseNumber ? el.exerciseNumber : '0'}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width="1">
                                            {el.ects ? el.ects : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width="1">
                                            {el.code ? el.code : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width={3}>
                                            {el.comment ? el.comment : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width={3}>
                                            {el.commentForStaff ? el.commentForStaff : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" textAlign="center" colSpan={1}>
                                            {localStorage.getItem('activeRole') !== 'Administrator' && localStorage.getItem('activeRole') !== 'AIDA' && <Link to={{ pathname: '/predmeti/implementacije/osoblje', state: { id: el.id } }}>
                                                <Button
                                                    compact
                                                    circular
                                                    icon={'users'}
                                                    basic="true"
                                                    size="small"
                                                    color="blue"
                                                    onClick={() => this.setState({
                                                        courseImplementationId: el.id,
                                                        addStaffMode: true,
                                                        newImplementationMode: false
                                                    })}
                                                />

                                            </Link>}

                                            {(localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' && localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' && localStorage.getItem('activeRole') !== 'Administrator' && localStorage.getItem('activeRole') !== 'AIDA') && <Button
                                                compact
                                                circular
                                                icon={"pencil"}
                                                basic="true"
                                                size="small"
                                                color="green"
                                                disabled={localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                                onClick={()=>this.setState({showEditForm: true, courseImplementation: el})}
                                           />}


                                            {(localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' && localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && <Popup
                                                content="Brisanje implementacije"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="trash alternate"
                                                        size="tiny"
                                                        color="red"
                                                        onClick={() => this.deleteImplementation(el.id)}
                                                    />}
                                            />}
                                        </Table.Cell>
                                    </Table.Row>))}
                                </Table.Body>
                            </Table>
                            : <NoDataMessageCurrent />
                    }
                </Tab.Pane>),
            },
            {
                menuItem: 'Prethodne akademske godine',
                render: () => (<Tab.Pane attached={false}>
                    <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={6} verticalAlign="right">
                                    {/* Akademska godina: */}
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={2} verticalAlign="left" width="5">
                                    <Form noValidate>
                                        <Form.Field>
                                            <Form.Dropdown
                                                clearable
                                                defaultValue={this.state.defaultPreviousYear}
                                                placeholder="Odaberite godinu"
                                                value={this.state.previousYear}
                                                onChange={this.handleInputChange}
                                                name="previousYear"
                                                options={this.state.previousYearOptions}
                                                search
                                                selection
                                            />
                                        </Form.Field>
                                    </Form>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                    { this.state.loader ?  <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :
                        this.state.previous.length ?
                            <React.Fragment>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={2}>
                                            Semestar (akademska godina)
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width="3">
                                            Predavanja + vježbe
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width="1">
                                            ECTS
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width="2">
                                            Šifra
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>
                                            Napomena
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={3}>
                                            <Header as="h4" image>
                                                <Header.Content>
                                                    Napomena
                                                    <Header.Subheader>za profesore</Header.Subheader>
                                                </Header.Content>
                                            </Header>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width="2"/>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {this.state.previous.map((el, index) =>
                                    (<Table.Row key={el.id}>

                                        <Table.Cell verticalAlign="middle" colSpan={2}>
                                            {el.semesters.length ? el.semesters[0].name.name : ''} ({el.semesters.length ? el.semesters[0].academicYear.name : ''})
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width="3">
                                            {el.lectureNumber ? el.lectureNumber : '0'} + {el.exerciseNumber ? el.exerciseNumber : '0'}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width="1">
                                            {el.ects ? el.ects : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width="2">
                                            {el.code ? el.code : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.comment ? el.comment : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.commentForStaff ? el.commentForStaff : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" textAlign="center" width="2">
                                            {localStorage.getItem('activeRole') !== 'Administrator' && localStorage.getItem('activeRole') !== 'AIDA' && <Link to={{ pathname: '/predmeti/implementacije/osoblje', state: { id: el.id, thirdCycle: this.state.thirdCycle, specialist: this.state.specialist, activeIndex:  this.state.activeIndex } }}>
                                                <Button
                                                    compact
                                                    circular
                                                    icon={'users'}
                                                    basic="true"
                                                    size="small"
                                                    color="blue"
                                                    onClick={() => this.setState({
                                                        courseImplementationId: el.id,
                                                        courseImplementation:el,
                                                        addStaffMode: true,
                                                        newImplementationMode: false,
                                                    })}/>
                                            </Link>}

                                            {(localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' && localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' && localStorage.getItem('activeRole') !== 'Administrator' && localStorage.getItem('activeRole') !== 'AIDA') && <Button
                                                    compact
                                                    circular
                                                    icon={"pencil"}
                                                    basic="true"
                                                    size="small"
                                                    color="green"
                                                    disabled={!this.state.thirdCycle || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || (localStorage.getItem('activeRole').substr(0, 30) === 'Služba za osiguranje kvaliteta' || localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja')}
                                                    onClick={()=>this.setState({showEditForm: true, courseImplementation: el})}
                                                />}

                                            {(localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' && localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' && localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska') && <Popup
                                                content="Brisanje implementacije"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="trash alternate"
                                                        size="tiny"
                                                        color="red"
                                                        onClick={() => this.deleteImplementation(el.id)}
                                                    />}
                                            />}
                                        </Table.Cell>
                                    </Table.Row>))}
                                </Table.Body>
                            </React.Fragment>
                            : <Table.Body><Table.Row >
                                <Table.Cell verticalAlign="middle" colSpan={6}>
                                    <NoDataMessage />
                                </Table.Cell></Table.Row></Table.Body>
                        } </Table>
                </Tab.Pane>),
            }];
        return (
            <div>
                <h1>Implementacije</h1>
                {this.state.addStaffMode ?
                    <AddStaff
                        closeAddStaffMode={() => this.setState({ addStaffMode: false })}
                        id={this.state.courseImplementationId}
                    />
                    : null}

                <Segment.Group raised >
                    <Segment clearing>
                        {(localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') || localStorage.getItem('activeRole').substr(0, 30) === 'Služba za osiguranje kvaliteta' ) ?
                            <Header as="h3">
                                {localStorage.getItem('courseBasicName')}
                                <Header.Subheader floated="left">
                                    {(localStorage.getItem('courseComment'))==='null' ? 'Predmet' : localStorage.getItem('courseComment')}
                                </Header.Subheader>
                            </Header> :
                        <Header as="h3">
                           {!this.state.newImplementationMode && <Header style={IconHeader} floated="right" >  <Button
                                color="blue"
                                floated="right"
                                icon
                                disabled={(!this.state.thirdCycle && !this.state.specialist && this.state.activeIndex === 1)  || localStorage.getItem('disableCreateImplementations')}
                                labelPosition="right"
                                size="small"
                                style={FiltersOnStyle}
                                onClick={() => this.setState({ newImplementationMode: true, addStaffMode: false })}
                            ><Icon className="add" />
                                Kreiranje implementacije predmeta
                            </Button></Header>}
                            {localStorage.getItem('courseBasicName')}
                            <Header.Subheader floated="left">
                                {(localStorage.getItem('courseComment'))==='null' ? 'Predmet' : localStorage.getItem('courseComment')}
                            </Header.Subheader>
                        </Header>}
                    </Segment>
                        {this.state.newImplementationMode ?
                            <Segment>
                            <CreateCourse
                                enableAddForPreviousYears={this.state.thirdCycle || this.state.specialist}
                                secondary
                                closeCreateCourseMode={() => {
                                    this.setState({ newImplementationMode: false });
                                }}
                                updateData={(yearId)=>{
                                    this.setState({ newImplementationMode: false });
                                    if(yearId===this.state.currentYear){
                                            this.setState({activeIndex: 0})
                                            this.getImplementations(localStorage.getItem('courseBasicId'));
                                        }else{
                                            this.setState({activeIndex: 1, previousYear:yearId})
                                            this.getImplementations(localStorage.getItem('courseBasicId'), yearId);
                                        }
                                }}
                            />
                            </Segment>
                            : null}
                    {this.state.showEditForm ?
                        <Segment>
                            <CreateCourse
                                edit
                                enableAddForPreviousYears
                                secondary
                                courseImplementation={this.state.courseImplementation}
                                editImplementation = {this.editImplementation}
                                closeCreateCourseMode={() => {
                                    this.setState({ newImplementationMode: false, showEditForm:false });
                                }}
                                updateData={(yearId)=>{
                                    this.setState({ newImplementationMode: false, showEditForm:false });
                                    if(yearId===this.state.currentYear){
                                        this.setState({activeIndex: 0})
                                        this.getImplementations(localStorage.getItem('courseBasicId'));
                                    }else{
                                        this.setState({activeIndex: 1, previousYear:yearId})
                                        this.getImplementations(localStorage.getItem('courseBasicId'), yearId);
                                    }
                                }}
                            />
</Segment>



                        : null}
                            <Segment clearing>
                                <Tab
                                    id="myTab"
                                    menu={{ color:'blue', secondary: true, pointing: true }}
                                    panes={panes}
                                    activeIndex={this.state.activeIndex}
                                    onTabChange={this.handleTabChange} />
                            </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/CreateCourseImplementation/CourseImplementations.js